const HL = [
    {id: "0", value: "漲幅"},    
    {id: "1", value: "跌幅"}, 
  ];  
  
  export default HL